import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../components/AuthContext";
import { toast } from "react-toastify";
import "../styles/Auth.css";

export default function RegisterPage() {
const { register } = useAuth();
const navigate = useNavigate();

const [form, setForm] = useState({
name: "",
email: "",
phone: "",
password: "",
confirmPassword: "",
});

const [loading, setLoading] = useState(false);
const [error, setError] = useState("");

const handleChange = (e) => {
let { name, value } = e.target;


if (name === "phone") value = value.replace(/\D/g, "");

setForm((prev) => ({ ...prev, [name]: value }));
setError(""); // 🔥 clear error on typing


};

const handleSubmit = async (e) => {
e.preventDefault();
setError("");


const { name, email, phone, password, confirmPassword } = form;

// 🔥 VALIDATIONS
if (!name || !email || !phone || !password || !confirmPassword) {
  setError("Please fill in all fields");
  return;
}

if (!/\S+@\S+\.\S+/.test(email)) {
  setError("Enter valid email");
  return;
}

if (phone.length < 10) {
  setError("Enter valid phone number");
  return;
}

if (password.length < 6) {
  setError("Password must be at least 6 characters");
  return;
}

if (password !== confirmPassword) {
  setError("Passwords do not match");
  return;
}

setLoading(true);

try {
  const res = await register(name, email, phone, password);

  if (res.success) {
    toast.success("OTP sent to your email");

    navigate("/verify-otp", {
      state: {
        source: "shop",
      },
    });

  } else {
    setError(res.message || "Registration failed");
  }

} catch {
  setError("Server error");
} finally {
  setLoading(false);
}

};

return ( <div className="auth-hero">
{/* LEFT */} <div className="auth-left"> <h1>Join the Ride</h1> <p>Create your SAC MTB account and explore premium cycles</p> </div>


  {/* RIGHT */}
  <div className="auth-card">
    <h2>Create Account</h2>

    {error && <p className="error-msg">{error}</p>}

    <form onSubmit={handleSubmit}>
      <input
        name="name"
        placeholder="Full Name"
        value={form.name}
        onChange={handleChange}
        required
      />

      <input
        name="email"
        type="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
      />

      <input
        name="phone"
        placeholder="Phone"
        value={form.phone}
        onChange={handleChange}
        maxLength={10}
        required
      />

      <input
        name="password"
        type="password"
        placeholder="Password"
        value={form.password}
        onChange={handleChange}
        required
      />

      {/* 🔥 NEW FIELD */}
      <input
        name="confirmPassword"
        type="password"
        placeholder="Confirm Password"
        value={form.confirmPassword}
        onChange={handleChange}
        required
      />

      <button type="submit" disabled={loading}>
        {loading ? "Creating..." : "Register"}
      </button>
    </form>

    <p className="auth-switch">
      Already have an account? <Link to="/login">Login</Link>
    </p>
  </div>
  
</div>


);
}
